import { useEffect } from 'react';

/**
 * While `active`, mirror the visual viewport (what is left of the screen once
 * the software keyboard is up) into CSS variables on <html>:
 *   --pp-vp-height, --pp-vp-offset
 * so fixed elements can size themselves to the visible area (the 3D column
 * above the keyboard in typing mode). Cleared when inactive.
 */
export default function useVisualViewportVars(active) {
  useEffect(() => {
    if (!active || typeof window === 'undefined') return undefined;
    const root = document.documentElement;
    const vv = window.visualViewport;
    const update = () => {
      root.style.setProperty('--pp-vp-height', `${Math.round(vv ? vv.height : window.innerHeight)}px`);
      root.style.setProperty('--pp-vp-offset', `${Math.round(vv ? vv.offsetTop : 0)}px`);
    };
    update();
    vv?.addEventListener('resize', update);
    vv?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      vv?.removeEventListener('resize', update);
      vv?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      root.style.removeProperty('--pp-vp-height');
      root.style.removeProperty('--pp-vp-offset');
    };
  }, [active]);
}
